import { createIcon, createImg } from './utils';

import logo from './logo.svg';
import logoWithText from './logoWithText.png';
import qr from './qr.svg';
import nGenius from './n-genius.png';
import nGeniusMini from './n-genius-mini.png';
import onTheGo from './on-the-go.png';
import guideCSV from './payrolls/guideCSVImage.png';

import { ReactComponent as StatsChart } from './icons/stats-chart.svg';
import { ReactComponent as MailOutline } from './icons/mail-outline.svg';
import { ReactComponent as Mail } from './icons/mail.svg';
import { ReactComponent as PersonOutline } from './icons/person-outline.svg';
import { ReactComponent as Location } from './icons/location.svg';
import { ReactComponent as QRcode } from './icons/qr-code.svg';
import { ReactComponent as Payroll } from './icons/payroll.svg';
import { ReactComponent as Question } from './icons/question.svg';
import { ReactComponent as GlobeOutline } from './icons/globe-outline.svg';
import { ReactComponent as Settings } from './icons/settings.svg';
import { ReactComponent as SwapHorizontal } from './icons/swap-horizontal.svg';
import { ReactComponent as Cash } from './icons/cash.svg';
import { ReactComponent as PhonePortraitOutline } from './icons/phone-portrait-outline.svg';
import { ReactComponent as Person } from './icons/person.svg';
import { ReactComponent as Globe } from './icons/globe.svg';
import { ReactComponent as PersonCircle } from './icons/person-circle.svg';
import { ReactComponent as Search } from './icons/search.svg';
import { ReactComponent as ArrowForward } from './icons/arrow-forward.svg';
import { ReactComponent as ChevronDown } from './icons/chevron-down.svg';
import { ReactComponent as Checkmark } from './icons/checkmark-outline.svg';
import { ReactComponent as ShieldCheckmark } from './icons/shield-checkmark.svg';
import { ReactComponent as Flag } from './icons/flag.svg';
import { ReactComponent as Flash } from './icons/flash.svg';
import { ReactComponent as FlashOff } from './icons/flash-off.svg';
import { ReactComponent as Remove } from './icons/remove-circle.svg';
import { ReactComponent as Dot } from './icons/ellipse.svg';
import { ReactComponent as Star } from './icons/star.svg';
import { ReactComponent as LogOut } from './icons/log-out-outline.svg';
import { ReactComponent as KeyOutline } from './icons/key-outline.svg';
import { ReactComponent as Language } from './icons/language-outline.svg';
import { ReactComponent as Save } from './icons/save.svg';
import { ReactComponent as TerminalAndroid } from './icons/terminal-android.svg';
import { ReactComponent as TerminalIos } from './icons/terminal-ios.svg';
import { ReactComponent as TerminalECommerce } from './icons/terminal-ecommerce.svg';
import { ReactComponent as TerminalDefault } from './icons/terminal-default.svg';
import { ReactComponent as TerminalNotActivated } from './icons/terminal-not-activated.svg';
import { ReactComponent as ArrowRedo } from './icons/arrow-redo.svg';
import { ReactComponent as Storefront } from './icons/storefront.svg';
import { ReactComponent as PaperPlane } from './icons/paper-plane.svg';
import { ReactComponent as EllipsisVertical } from './icons/ellipsis-vertical.svg';
import { ReactComponent as Marker } from './icons/marker.svg';
import { ReactComponent as ArrowDown } from './icons/arrow-down.svg';
import { ReactComponent as Close } from './icons/close.svg';
import { ReactComponent as ResetPasswordFail } from './icons/reset-password-fail.svg';
import { ReactComponent as ResetPasswordSuccess } from './icons/reset-password-success.svg';
import { ReactComponent as ResetPasswordEmailSent } from './icons/reset-password-email-sent.svg';
import { ReactComponent as Edit } from './icons/edit.svg';
import { ReactComponent as Copy } from './icons/copy.svg';
import { ReactComponent as Beneficiaries } from './icons/beneficiaries.svg';
import { ReactComponent as Transfer } from './icons/transfer.svg';

import { ReactComponent as BusinessPasswordReset } from './icons/resetPassword/business.svg';
import { ReactComponent as WalletPasswordReset } from './icons/resetPassword/wallet.svg';
import { ReactComponent as GooglePlayBadgeAFZA } from './icons/resetPassword/google-play/badge-google-play-af-ZA.svg';
import { ReactComponent as GooglePlayBadgeARAE } from './icons/resetPassword/google-play/badge-google-play-ar-AE.svg';
import { ReactComponent as GooglePlayBadgeAREG } from './icons/resetPassword/google-play/badge-google-play-ar-EG.svg';
import { ReactComponent as GooglePlayBadgeARJO } from './icons/resetPassword/google-play/badge-google-play-ar-JO.svg';
import { ReactComponent as GooglePlayBadgeARMA } from './icons/resetPassword/google-play/badge-google-play-ar-MA.svg';
import { ReactComponent as GooglePlayBadgeARSA } from './icons/resetPassword/google-play/badge-google-play-ar-SA.svg';
import { ReactComponent as GooglePlayBadgeDEDE } from './icons/resetPassword/google-play/badge-google-play-de-DE.svg';
import { ReactComponent as GooglePlayBadgeENGB } from './icons/resetPassword/google-play/badge-google-play-en-GB.svg';
import { ReactComponent as GooglePlayBadgeENUS } from './icons/resetPassword/google-play/badge-google-play-en-US.svg';
import { ReactComponent as GooglePlayBadgeESES } from './icons/resetPassword/google-play/badge-google-play-es-ES.svg';
import { ReactComponent as GooglePlayBadgeESMX } from './icons/resetPassword/google-play/badge-google-play-es-MX.svg';
import { ReactComponent as GooglePlayBadgeFRCA } from './icons/resetPassword/google-play/badge-google-play-fr-CA.svg';
import { ReactComponent as GooglePlayBadgeFRFR } from './icons/resetPassword/google-play/badge-google-play-fr-FR.svg';
import { ReactComponent as GooglePlayBadgeITIT } from './icons/resetPassword/google-play/badge-google-play-it-IT.svg';
import { ReactComponent as GooglePlayBadgePTBR } from './icons/resetPassword/google-play/badge-google-play-pt-BR.svg';
import { ReactComponent as GooglePlayBadgeRORO } from './icons/resetPassword/google-play/badge-google-play-ro-RO.svg';
import { ReactComponent as GooglePlayBadgeRURU } from './icons/resetPassword/google-play/badge-google-play-ru-RU.svg';
import { ReactComponent as GooglePlayBadgeSWKE } from './icons/resetPassword/google-play/badge-google-play-sw-KE.svg';
import { ReactComponent as GooglePlayBadgeTRTR } from './icons/resetPassword/google-play/badge-google-play-tr-TR.svg';
import { ReactComponent as GooglePlayBadgeYONG } from './icons/resetPassword/google-play/badge-google-play-yo-NG.svg';
import { ReactComponent as AppStoreBadgeAFZA } from './icons/resetPassword/app-store/badge-app-store-af-ZA.svg';
import { ReactComponent as AppStoreBadgeARAE } from './icons/resetPassword/app-store/badge-app-store-ar-AE.svg';
import { ReactComponent as AppStoreBadgeAREG } from './icons/resetPassword/app-store/badge-app-store-ar-EG.svg';
import { ReactComponent as AppStoreBadgeARMA } from './icons/resetPassword/app-store/badge-app-store-ar-MA.svg';
import { ReactComponent as AppStoreBadgeARJO } from './icons/resetPassword/app-store/badge-app-store-ar-JO.svg';
import { ReactComponent as AppStoreBadgeARSA } from './icons/resetPassword/app-store/badge-app-store-ar-SA.svg';
import { ReactComponent as AppStoreBadgeDEDE } from './icons/resetPassword/app-store/badge-app-store-de-DE.svg';
import { ReactComponent as AppStoreBadgeENGB } from './icons/resetPassword/app-store/badge-app-store-en-GB.svg';
import { ReactComponent as AppStoreBadgeENUS } from './icons/resetPassword/app-store/badge-app-store-en-US.svg';
import { ReactComponent as AppStoreBadgeESES } from './icons/resetPassword/app-store/badge-app-store-es-ES.svg';
import { ReactComponent as AppStoreBadgeESMX } from './icons/resetPassword/app-store/badge-app-store-es-MX.svg';
import { ReactComponent as AppStoreBadgeFRCA } from './icons/resetPassword/app-store/badge-app-store-fr-CA.svg';
import { ReactComponent as AppStoreBadgeFRFR } from './icons/resetPassword/app-store/badge-app-store-fr-FR.svg';
import { ReactComponent as AppStoreBadgeITIT } from './icons/resetPassword/app-store/badge-app-store-it-IT.svg';
import { ReactComponent as AppStoreBadgePTBR } from './icons/resetPassword/app-store/badge-app-store-pt-BR.svg';
import { ReactComponent as AppStoreBadgeRORO } from './icons/resetPassword/app-store/badge-app-store-ro-RO.svg';
import { ReactComponent as AppStoreBadgeRURU } from './icons/resetPassword/app-store/badge-app-store-ru-RU.svg';
import { ReactComponent as AppStoreBadgeSWKE } from './icons/resetPassword/app-store/badge-app-store-sw-KE.svg';
import { ReactComponent as AppStoreBadgeTRTR } from './icons/resetPassword/app-store/badge-app-store-tr-TR.svg';
import { ReactComponent as AppStoreBadgeYONG } from './icons/resetPassword/app-store/badge-app-store-yo-NG.svg';


import { ReactComponent as TerminalPlaceholder } from './terminalPlaceholder.svg';
import { ReactComponent as CurrentPosted } from './currentPosted.svg';
import { ReactComponent as CurrentPending } from './currentPending.svg';
import { ReactComponent as CurrentAvailable } from './currentAvailable.svg';
import { ReactComponent as ProcessedInRealTime } from './processedInRealTime.svg';

export const LogoImg = createImg(logo, 'logo');
export const LogoWithTextImg = createImg(logoWithText, 'logo');
export const QrImg = createImg(qr, 'qr');
export const NGenius = createImg(nGenius, 'nGenius');
export const NGeniusMini = createImg(nGeniusMini, 'nGeniusMini');
export const OnTheGo = createImg(onTheGo, 'onTheGo');
export const GuideCSV = createImg(guideCSV, 'guideCSV');

export const StatsChartIcon = createIcon(StatsChart);
export const MailOutlineIcon = createIcon(MailOutline);
export const MailIcon = createIcon(Mail);
export const EllipseIcon = createIcon(Dot);
export const PersonOutlineIcon = createIcon(PersonOutline);
export const LocationIcon = createIcon(Location);
export const QRcodeIcon = createIcon(QRcode);
export const PayrollIcon = createIcon(Payroll);
export const QuestionIcon = createIcon(Question);
export const GlobeOutlineIcon = createIcon(GlobeOutline);
export const SettingsIcon = createIcon(Settings);
export const SwapHorizontalIcon = createIcon(SwapHorizontal);
export const CashIcon = createIcon(Cash);
export const PhonePortraitOutlineIcon = createIcon(PhonePortraitOutline);
export const PersonIcon = createIcon(Person);
export const GlobeIcon = createIcon(Globe);
export const PersonCircleIcon = createIcon(PersonCircle);
export const SearchIcon = createIcon(Search);
export const ArrowForwardIcon = createIcon(ArrowForward);
export const ArrowDownIcon = createIcon(ArrowDown);
export const ChevronDownIcon = createIcon(ChevronDown);
export const TerminalPlaceholderImg = createIcon(TerminalPlaceholder);
export const CurrentPostedIcon = createIcon(CurrentPosted);
export const CurrentPendingIcon = createIcon(CurrentPending);
export const CurrentAvailableIcon = createIcon(CurrentAvailable);
export const ProcessedInRealTimeIcon = createIcon(ProcessedInRealTime);
export const CheckmarkIcon = createIcon(Checkmark);
export const ShieldCheckmarkIcon = createIcon(ShieldCheckmark);
export const FlagIcon = createIcon(Flag);
export const FlashIcon = createIcon(Flash);
export const FlashOffIcon = createIcon(FlashOff);
export const RemoveIcon = createIcon(Remove);
export const DotIcon = createIcon(Dot);
export const StarIcon = createIcon(Star);
export const LogOutIcon = createIcon(LogOut);
export const KeyOutlineIcon = createIcon(KeyOutline);
export const LanguageIcon = createIcon(Language);
export const SaveIcon = createIcon(Save);
export const TerminalAndroidIcon = createIcon(TerminalAndroid);
export const TerminalIosIcon = createIcon(TerminalIos);
export const TerminalECommerceIcon = createIcon(TerminalECommerce);
export const TerminalDefaultIcon = createIcon(TerminalDefault);
export const TerminalNotActivatedIcon = createIcon(TerminalNotActivated);
export const ArrowRedoIcon = createIcon(ArrowRedo);
export const BusinessIcon = createIcon(Storefront);
export const SendIcon = createIcon(PaperPlane);
export const EllipsisVerticalIcon = createIcon(EllipsisVertical);
export const MarkerIcon = createIcon(Marker);
export const CloseIcon = createIcon(Close);
export const ResetPasswordFailIcon = createIcon(ResetPasswordFail);
export const ResetPasswordSuccessIcon = createIcon(ResetPasswordSuccess);
export const ResetPasswordEmailSentIcon = createIcon(ResetPasswordEmailSent);
export const EditIcon = createIcon(Edit);
export const CopyIcon = createIcon(Copy);
export const BeneficiariesIcon = createIcon(Beneficiaries);
export const TransferIcon = createIcon(Transfer);

export const BusinessPasswordResetIcon = createIcon(BusinessPasswordReset);
export const WalletPasswordResetIcon = createIcon(WalletPasswordReset);
export const GooglePlayBadgeAFZAIcon = createIcon(GooglePlayBadgeAFZA);
export const GooglePlayBadgeARAEIcon = createIcon(GooglePlayBadgeARAE);
export const GooglePlayBadgeAREGIcon = createIcon(GooglePlayBadgeAREG);
export const GooglePlayBadgeARJOIcon = createIcon(GooglePlayBadgeARJO);
export const GooglePlayBadgeARMAIcon = createIcon(GooglePlayBadgeARMA);
export const GooglePlayBadgeARSAIcon = createIcon(GooglePlayBadgeARSA);
export const GooglePlayBadgeDEDEIcon = createIcon(GooglePlayBadgeDEDE);
export const GooglePlayBadgeENGBIcon = createIcon(GooglePlayBadgeENGB);
export const GooglePlayBadgeENUSIcon = createIcon(GooglePlayBadgeENUS);
export const GooglePlayBadgeESESIcon = createIcon(GooglePlayBadgeESES);
export const GooglePlayBadgeESMXIcon = createIcon(GooglePlayBadgeESMX);
export const GooglePlayBadgeFRCAIcon = createIcon(GooglePlayBadgeFRCA);
export const GooglePlayBadgeFRFRIcon = createIcon(GooglePlayBadgeFRFR);
export const GooglePlayBadgeITITIcon = createIcon(GooglePlayBadgeITIT);
export const GooglePlayBadgePTBRIcon = createIcon(GooglePlayBadgePTBR);
export const GooglePlayBadgeROROIcon = createIcon(GooglePlayBadgeRORO);
export const GooglePlayBadgeRURUIcon = createIcon(GooglePlayBadgeRURU);
export const GooglePlayBadgeSWKEIcon = createIcon(GooglePlayBadgeSWKE);
export const GooglePlayBadgeTRTRIcon = createIcon(GooglePlayBadgeTRTR);
export const GooglePlayBadgeYONGIcon = createIcon(GooglePlayBadgeYONG);

export const AppStoreBadgeAFZAIcon = createIcon(AppStoreBadgeAFZA);
export const AppStoreBadgeARAEIcon = createIcon(AppStoreBadgeARAE);
export const AppStoreBadgeAREGIcon = createIcon(AppStoreBadgeAREG);
export const AppStoreBadgeARJOIcon = createIcon(AppStoreBadgeARJO);
export const AppStoreBadgeARMAIcon = createIcon(AppStoreBadgeARMA);
export const AppStoreBadgeARSAIcon = createIcon(AppStoreBadgeARSA);
export const AppStoreBadgeDEDEIcon = createIcon(AppStoreBadgeDEDE);
export const AppStoreBadgeENGBIcon = createIcon(AppStoreBadgeENGB);
export const AppStoreBadgeENUSIcon = createIcon(AppStoreBadgeENUS);
export const AppStoreBadgeESESIcon = createIcon(AppStoreBadgeESES);
export const AppStoreBadgeESMXIcon = createIcon(AppStoreBadgeESMX);
export const AppStoreBadgeFRCAIcon = createIcon(AppStoreBadgeFRCA);
export const AppStoreBadgeFRFRIcon = createIcon(AppStoreBadgeFRFR);
export const AppStoreBadgeITITIcon = createIcon(AppStoreBadgeITIT);
export const AppStoreBadgePTBRIcon = createIcon(AppStoreBadgePTBR);
export const AppStoreBadgeROROIcon = createIcon(AppStoreBadgeRORO);
export const AppStoreBadgeRURUIcon = createIcon(AppStoreBadgeRURU);
export const AppStoreBadgeSWKEIcon = createIcon(AppStoreBadgeSWKE);
export const AppStoreBadgeTRTRIcon = createIcon(AppStoreBadgeTRTR);
export const AppStoreBadgeYONGIcon = createIcon(AppStoreBadgeYONG);

